var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1686(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1686",
    "data-name": "Groupe 1686",
    transform: "translate(-10841 -1008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1295",
    "data-name": "Rectangle 1295",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(10841 1008)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_medal-star",
    "data-name": "vuesax/linear/medal-star",
    transform: "translate(10187 791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medal-star",
    transform: "translate(684 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.583,10.792A10.719,10.719,0,0,1,12.41,21.445a9.512,9.512,0,0,1-3.238,0,10.784,10.784,0,1,1,12.41-10.653Z",
    transform: "translate(7.708 3.083)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M29.709,8.587l-2.544.6a1.513,1.513,0,0,0-1.141,1.141l-.54,2.266a1.542,1.542,0,0,1-2.682.632L15.448,4.779,8.095,13.243a1.542,1.542,0,0,1-2.683-.632l-.54-2.266A1.536,1.536,0,0,0,3.732,9.2L1.188,8.6a1.546,1.546,0,0,1-.74-2.59L6.46,0A10.769,10.769,0,0,0,13.83,4.656a9.3,9.3,0,0,0,1.619.139,9.3,9.3,0,0,0,1.619-.139A10.769,10.769,0,0,0,24.436,0l6.012,6.012A1.535,1.535,0,0,1,29.709,8.587Z",
    transform: "translate(3.052 19.887)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6,.74l.91,1.819a1.117,1.117,0,0,0,.74.54l1.65.277c1.048.17,1.295.94.54,1.7l-1.28,1.28a1.092,1.092,0,0,0-.262.94l.37,1.588c.293,1.249-.37,1.742-1.48,1.079L5.649,9.05a1.081,1.081,0,0,0-1.018,0l-1.542.91c-1.11.648-1.773.17-1.48-1.079l.37-1.588a1.157,1.157,0,0,0-.262-.94L.438,5.072c-.755-.755-.509-1.511.54-1.7L2.628,3.1a1.123,1.123,0,0,0,.725-.54L4.262.74C4.709-.247,5.511-.247,6,.74Z",
    transform: "translate(13.39 8.479)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H37V37H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1686);
export default __webpack_public_path__ + "static/media/Groupe-1686.a90ef6536842ca12792c96ad8a0fd08e.svg";
export { ForwardRef as ReactComponent };